import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f9228926&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=f9228926&prod&lang=less&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=f9228926&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9228926",
  null
  
)

export default component.exports